<template>
  <el-dialog
    title="会话全链路明细报表"
    :visible.sync="dialogVisible"
    width="1200px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <!-- 筛选条件栏 -->
    <div class="filter-bar">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        style="width: 280px;"
        @change="onDateChange"
      />

      <el-select
        v-model="workspaceSlug"
        placeholder="选择知识库"
        size="small"
        clearable
        filterable
        style="width: 180px; margin-left: 12px;"
        @change="onSearch"
      >
        <el-option
          v-for="ws in workspaceList"
          :key="ws.slug"
          :label="ws.name"
          :value="ws.slug"
        />
      </el-select>

      <el-input
        v-model="keyword"
        placeholder="搜索会话标题/内容"
        size="small"
        clearable
        style="width: 220px; margin-left: 12px;"
        @keyup.enter.native="onSearch"
        @clear="onSearch"
      >
        <i slot="prefix">
          <svg t="1783174517527" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1669" width="32" height="32">
            <path d="M868.629499 838.278052L683.630205 653.278758c46.972477-54.921665 72.265349-124.296401 72.265349-197.284404 0-168.378264-137.304164-305.682428-305.682428-305.682427C281.834862 150.311927 144.530699 287.61609 144.530699 455.994354c0 168.378264 137.304164 305.682428 305.682427 305.682428 44.804517 0 88.163726-9.394495 129.354976-28.90614 13.007763-5.781228 18.066337-20.956951 12.285109-33.964714C585.34933 686.520819 570.89626 680.739591 557.888497 686.520819c-33.964714 15.898377-70.097389 23.847565-107.675371 23.847565C310.018349 710.368384 195.116443 596.189132 195.116443 455.271701c0-140.194778 114.179252-255.096683 255.096683-255.096683 140.194778 0 255.096683 114.179252 255.096683 255.096683 0 67.929428-26.738179 132.245589-74.433309 179.94072-10.117149 10.117149-10.117149 26.015526 0 36.132674l202.342978 202.342978c5.058574 5.058574 11.562456 7.226535 18.066337 7.226535s13.007763-2.16796 18.066337-7.226535c8.671842-9.394495 8.671842-26.015526-0.722653-35.410021z" fill="#cdcdcd" p-id="1670"/>
            <path d="M286.893437 376.50247m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1671"/>
            <path d="M268.104446 473.338038m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1672"/>
            <path d="M311.463656 554.997883m-27.460833 0a27.460833 27.460833 0 1 0 54.921665 0 27.460833 27.460833 0 1 0-54.921665 0Z" fill="#cdcdcd" p-id="1673"/>
          </svg>
        </i>
      </el-input>

      <el-button type="primary" size="small" @click="onSearch" style="margin-left: 12px;">
        <i>
          <svg t="1783174517527" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1669" width="16" height="16">
            <path d="M868.629499 838.278052L683.630205 653.278758c46.972477-54.921665 72.265349-124.296401 72.265349-197.284404 0-168.378264-137.304164-305.682428-305.682428-305.682427C281.834862 150.311927 144.530699 287.61609 144.530699 455.994354c0 168.378264 137.304164 305.682428 305.682427 305.682428 44.804517 0 88.163726-9.394495 129.354976-28.90614 13.007763-5.781228 18.066337-20.956951 12.285109-33.964714C585.34933 686.520819 570.89626 680.739591 557.888497 686.520819c-33.964714 15.898377-70.097389 23.847565-107.675371 23.847565C310.018349 710.368384 195.116443 596.189132 195.116443 455.271701c0-140.194778 114.179252-255.096683 255.096683-255.096683 140.194778 0 255.096683 114.179252 255.096683 255.096683 0 67.929428-26.738179 132.245589-74.433309 179.94072-10.117149 10.117149-10.117149 26.015526 0 36.132674l202.342978 202.342978c5.058574 5.058574 11.562456 7.226535 18.066337 7.226535s13.007763-2.16796 18.066337-7.226535c8.671842-9.394495 8.671842-26.015526-0.722653-35.410021z" fill="#cdcdcd" p-id="1670"/>
            <path d="M286.893437 376.50247m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1671"/>
            <path d="M268.104446 473.338038m-27.460833 0a27.460833 27.460833 0 1 0 54.921666 0 27.460833 27.460833 0 1 0-54.921666 0Z" fill="#cdcdcd" p-id="1672"/>
            <path d="M311.463656 554.997883m-27.460833 0a27.460833 27.460833 0 1 0 54.921665 0 27.460833 27.460833 0 1 0-54.921665 0Z" fill="#cdcdcd" p-id="1673"/>
          </svg>
        </i> 查询
      </el-button>

      <el-button size="small" @click="handleExport">
        <i>
          <svg t="1783182461564" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2783" width="16" height="16">
            <path d="M469.333333 682.666667V42.666667c0-23.466667 19.2-42.666667 42.666667-42.666667s42.666667 19.2 42.666667 42.666667v640c0 23.466667-19.2 42.666667-42.666667 42.666666s-42.666667-19.2-42.666667-42.666666" fill="#bfbfbf" p-id="2784"/>
            <path d="M226.210133 268.0576L481.826133 12.433067a42.7776 42.7776 0 0 1 60.330667 0c16.597333 16.597333 16.597333 43.776 0 60.330666L286.5408 328.388267a42.7776 42.7776 0 0 1-60.330667 0 42.7776 42.7776 0 0 1 0-60.330667" fill="#bfbfbf" p-id="2785"/>
            <path d="M542.0544 12.4416l255.616 255.616a42.7776 42.7776 0 0 1 0 60.330667c-16.597333 16.605867-43.776 16.605867-60.330667 0L481.723733 72.789333a42.7776 42.7776 0 0 1 0-60.330666 42.7776 42.7776 0 0 1 60.330667 0M896 1024H128c-70.570667 0-128-57.429333-128-128V640c0-23.594667 19.072-42.666667 42.666667-42.666667s42.666667 19.072 42.666666 42.666667v256c0 23.552 19.114667 42.666667 42.666667 42.666667h768c23.552 0 42.666667-19.114667 42.666667-42.666667V640c0-23.594667 19.072-42.666667 42.666666-42.666667s42.666667 19.072 42.666667 42.666667v256c0 70.570667-57.429333 128-128 128" fill="#bfbfbf" p-id="2786"/>
          </svg>
        </i> 导出
      </el-button>

      <span style="margin-left: 16px; color: #909399; font-size: 13px;">
        共 {{ total }} 个会话
      </span>
    </div>

    <!-- 表格 -->
    <el-table
      ref="conversationTable"
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%; margin-top: 12px;"
      max-height="500"
    >
      <el-table-column type="index" label="序号" width="55" align="center" />
      
      <!-- el-table-column prop="conversationId" label="会话ID" width="120" align="center">
        <template slot-scope="{ row }">
          <el-button
            type="text"
            size="mini"
            style="color: #409EFF; font-weight: 600;"
            @click="showConversationDetail(row)"
          >
            {{ row.conversationId }}
          </el-button>
        </template>
      </el-table-column -->
      
      <el-table-column prop="conversationTitle" label="会话标题" min-width="150" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.conversationTitle">{{ row.conversationTitle }}</span>
          <span v-else style="color: #c0c4cc;">未命名会话</span>
        </template>
      </el-table-column>
      
      <el-table-column prop="workspaceSlug" label="知识库" width="120" align="center" show-overflow-tooltip />
      
      <!--  el-table-column prop="customerId" label="用户" width="120" align="center" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.customerId">{{ row.customerId }}</span>
          <span v-else style="color: #c0c4cc;">-</span>
        </template>
      </el-table-column -->     
  
      <el-table-column prop="hitCount" label="是否命中" width="80" align="center" >
                <template slot-scope="{ row }">
          <span v-if="row.customerId">{{ row.hitCount>0?'命中':'未命中' }}</span>
          <span v-else style="color: #c0c4cc;">-</span>
        </template>
      </el-table-column>
      
     <el-table-column prop="matched_document_title" label="命中文档" width="90" align="center" />
           
      <!-- el-table-column prop="hitRate" label="命中率" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.hitRate >= 70 ? 'success' : row.hitRate >= 40 ? 'warning' : 'danger'" size="mini">
            {{ row.hitRate ? row.hitRate.toFixed(1) : 0 }}%
          </el-tag>
        </template>
      </el-table-column -->
      
      <el-table-column prop="avgResponseTimeMs" label="平均响应时间(ms)" width="110" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.avgResponseTimeMs !== null">
            {{ Math.abs(row.avgResponseTimeMs.toFixed(0)) }}
          </span>
          <span v-else style="color: #c0c4cc;">-</span>
        </template>
      </el-table-column>
      
      <!-- el-table-column prop="messageCount" label="对话轮次" width="90" align="center" /  -->
      
      <el-table-column prop="firstQueryTime" label="首次出现时间" width="160" align="center">
        <template slot-scope="{ row }">
          {{ formatDateTime(row.firstQueryTime) }}
        </template>
      </el-table-column>
      
      <el-table-column prop="lastQueryTime" label="最后出现时间" width="160" align="center">
        <template slot-scope="{ row }">
          {{ formatDateTime(row.lastQueryTime) }}
        </template>
      </el-table-column>
      
      <el-table-column label="操作" width="80" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" size="mini" @click="showConversationDetail(row)">
            查看明细
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onPageChange"
        :current-page="page + 1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>

    <!-- 内嵌会话详情弹窗 -->
    <el-dialog
      title="会话详情"
      :visible.sync="detailDialogVisible"
      width="1000px"
      append-to-body
      :close-on-click-modal="false"
      @close="handleDetailClose"
    >
      <div class="detail-header">
        <span class="detail-info">
          <strong>会话ID:</strong> {{ currentConversationId }}
          <span style="margin-left: 20px;"><strong>会话标题:</strong> {{ currentConversationTitle || '未命名' }}</span>
          <span style="margin-left: 20px;"><strong>消息数:</strong> {{ detailMessages.length }}</span>
        </span>
      </div>
      
      <el-table
        :data="detailMessages"
        v-loading="detailLoading"
        border
        stripe
        style="width: 100%; margin-top: 12px;"
        max-height="450"
      >
        <el-table-column type="index" label="序号" width="55" align="center" />
        
        <el-table-column prop="role" label="角色" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.role === 'user' ? 'primary' : 'success'" size="mini">
              {{ row.role === 'user' ? '用户' : 'AI' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column prop="content" label="消息内容" min-width="300">
          <template slot-scope="{ row }">
            <div class="message-content">{{ row.content }}</div>
          </template>
        </el-table-column>
        
        <!-- el-table-column prop="isHit" label="是否命中" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.isHit === 1 ? 'success' : 'danger'" size="mini">
              {{ row.isHit === 1 ? '命中' : '未命中' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column prop="hitDocTitle" label="命中文档" width="150" show-overflow-tooltip >
          <template slot-scope="{ row }">
            <span v-if="row.hitDocTitle">{{ row.hitDocTitle }}</span>
            <span v-else style="color: #c0c4cc;">-</span>
          </template>
        </el-table-column -->
        
        <el-table-column prop="confidence" label="置信度" width="90" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.confidence !== null">{{ (row.confidence * 100).toFixed(1) }}%</span>
            <span v-else style="color: #c0c4cc;">-</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="responseTimeMs" label="响应时间(ms)" width="110" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.responseTimeMs !== null">{{ row.responseTimeMs }}</span>
            <span v-else style="color: #c0c4cc;">-</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="queryTime" label="时间" width="160" align="center">
          <template slot-scope="{ row }">
            {{ formatDateTime(row.queryTime) }}
          </template>
        </el-table-column>
      </el-table>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getConversationList, getConversationDetail } from '@/api/dashboard'
import { getWorkspaceListByTenant } from '@/api/workspace'
import { exportFeedbackDetail } from '@/api/dashboard'

export default {
  name: 'ConversationListDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      detailLoading: false,
      tableData: [],
      total: 0,
      page: 0,
      size: 20,
      dateRange: this.getDefaultDateRange(),
      workspaceSlug: '',
      keyword: '',
      workspaceList: [],
      
      // 详情弹窗
      detailDialogVisible: false,
      currentConversationId: null,
      currentConversationTitle: '',
      detailMessages: [],
      
      pickerOptions: {
        shortcuts: [
          { text: '近7天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }},
          { text: '近30天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }},
          { text: '近90天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }}
        ]
      }
    }
  },
  computed: {
    tenantId() {
      return this.$store.getters['auth/currentTenant']?.tenantId || null
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.page = 0
      this.dateRange = this.getDefaultDateRange()
      this.workspaceSlug = ''
      this.keyword = ''
      this.loadWorkspaceList()
      this.loadData()
    },
    close() {
      this.dialogVisible = false
    },
    handleClose() {
      this.dialogVisible = false
    },
    
    getDefaultDateRange() {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 30)
      return [this.formatDate(start), this.formatDate(end)]
    },
    
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    
    formatDateTime(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      if (isNaN(date.getTime())) return dateStr
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    
    /**
     * 加载工作区列表
     * 调用 /aics/kb_workspace/find_by_tenant API
     */
    async loadWorkspaceList() {
      if (!this.tenantId) {
        console.warn('tenantId 为空，无法加载工作区列表')
        return
      }

      try {
        const res = await getWorkspaceListByTenant(this.tenantId)
        console.log('工作区列表响应:', res)

        if (res?.data?.code === 200) {
          const data = res.data.data
          if (Array.isArray(data) && data.length > 0) {
            this.workspaceList = data.map(item => ({
              slug: item.slug,
              name: item.name,
              id: item.id
            }))
            console.log('工作区列表加载成功，共 ' + this.workspaceList.length + ' 个')
          } else {
            this.workspaceList = []
          }
        } else {
          this.workspaceList = []
        }
      } catch (error) {
        console.error('加载工作区列表失败:', error)
        this.workspaceList = []
      }
    },
    
    onDateChange() {
      this.page = 0
      this.loadData()
    },
    onSearch() {
      this.page = 0
      this.loadData()
    },
    onPageChange(page) {
      this.page = page -1
      this.loadData()
    },
    onSizeChange(size) {
      this.size = size
      this.page = 0
      this.loadData()
    },
    
    async loadData() {
      if (!this.tenantId) {
        this.$message.warning('请先登录')
        return
      }
      
      this.loading = true
      try {
        const params = {
          tenantId: this.tenantId,
          startTime: this.dateRange[0] + ' 00:00:00',
          endTime: this.dateRange[1] + ' 23:59:59',
          page: this.page,
          size: this.size,
          keyword: this.keyword || '',
          workspaceSlug: this.workspaceSlug || ''
        }
        
        const res = await getConversationList(params)
        console.log('会话列表响应:', res)
        
        if (res?.data?.code === 200) {
          const data = res.data.data
          this.tableData = data?.content || []
          this.total = data?.total_elements || 0
          //this.page = data?.pageable?.number || 0
        } else {
          this.$message.error(res?.data?.message || '加载失败')
          this.tableData = []
          this.total = 0
        }
      } catch (error) {
        console.error('加载会话列表失败:', error)
        this.$message.error('加载失败: ' + (error.message || '未知错误'))
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    
    async showConversationDetail(row) {
      this.currentConversationId = row.conversationId
      this.currentConversationTitle = row.conversationTitle || '未命名会话'
      this.detailDialogVisible = true
      this.detailMessages = []
      
      this.detailLoading = true
      try {
        const res = await getConversationDetail(this.currentConversationId, this.tenantId)
        console.log('会话详情响应:', res)
        
        if (res?.data?.code === 200) {
          this.detailMessages = res.data.data || []
        } else {
          this.$message.error(res?.data?.message || '加载会话详情失败')
        }
      } catch (error) {
        console.error('加载会话详情失败:', error)
        this.$message.error('加载会话详情失败: ' + (error.message || '未知错误'))
      } finally {
        this.detailLoading = false
      }
    },
    
    handleDetailClose() {
      this.detailDialogVisible = false
      this.detailMessages = []
      this.currentConversationId = null
      this.currentConversationTitle = ''
    },
    
   async handleExport() {
        this.exportLoading = true
        
        try {
          const params = {
            tenantId: this.$store.state.auth.tenantInfo.tenantId,
            startTime: this.dateRange[0],
            endTime: this.dateRange[1],
          //  isHit: this.hitFilter === 'all' ? undefined : parseInt(this.hitFilter),
            keyword: this.keyword || undefined
          }
          
          // 调用导出接口
          const response = await exportFeedbackDetail(params)
          
          // 处理文件下载
          const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          
          // 从响应头获取文件名
          const disposition = response.headers['content-disposition']
          let fileName = '用户反馈明细.xlsx'
          if (disposition) {
            const match = disposition.match(/filename=(.+)/)
            if (match) fileName = decodeURIComponent(match[1])
          }
          
          link.download = fileName
          link.click()
          URL.revokeObjectURL(link.href)
          
          this.$message.success('导出成功')
        } catch (error) {
          console.error('导出失败:', error)
          this.$message.error('导出失败，请重试')
        } finally {
          this.exportLoading = false
        }
    },


 }    
  
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

::v-deep .el-dialog__body {
  padding: 20px 20px 10px 20px;
}

.detail-header {
  padding: 12px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 12px;
}

.detail-info {
  font-size: 14px;
  color: #606266;
}

.message-content {
  max-height: 80px;
  overflow-y: auto;
  word-break: break-word;
  line-height: 1.5;
}

/* ===== 分页器样式（与反馈明细一致） ===== */
::v-deep .el-pagination .btn-prev .el-icon,
::v-deep .el-pagination .btn-next .el-icon,
::v-deep .el-pagination .el-icon-arrow-left,
::v-deep .el-pagination .el-icon-arrow-right {
  display: none !important;
}

::v-deep .el-pagination .btn-prev {
  position: relative;
}
::v-deep .el-pagination .btn-prev::after {
  content: '<' !important;
  font-size: 14px !important;
  font-family: sans-serif !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #606266;
}

::v-deep .el-pagination .btn-next {
  position: relative;
}
::v-deep .el-pagination .btn-next::after {
  content: '>' !important;
  font-size: 14px !important;
  font-family: sans-serif !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #606266;
}

::v-deep .el-input__clear {
  display: none !important;
}

::v-deep .el-input__prefix {
  display: flex !important;
  align-items: center !important;
  left: 5px !important;
}
</style>